import { render, staticRenderFns } from "./PostsFilters.vue?vue&type=template&id=abb26646&scoped=true"
import script from "./PostsFilters.vue?vue&type=script&lang=js"
export * from "./PostsFilters.vue?vue&type=script&lang=js"
import style0 from "./PostsFilters.vue?vue&type=style&index=0&id=abb26646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb26646",
  null
  
)

export default component.exports